import { useAppMutation } from '@/hooks/api';
import { API_ROUTES } from '@/constants/api-routes';
import mutationKeys from '@/constants/mutationKeys';

export const useDeleteTemplateMutation = (templateId: string) => {
  return useAppMutation<void, { force?: boolean }>({
    routeName: API_ROUTES.DELETE_TEMPLATE.replace(':templateId', templateId),
    mutationKey: [mutationKeys.TEMPLATE_GALLERY_DELETE_TEMPLATE, templateId],
    method: 'DELETE',
  });
};